import { ORDER_STATUSES } from "../helpers/constants";

export interface CustomerSuspensionParams {
  fetchCustomerOrderListInProgress: boolean;
  fetchCustomerOrderListSuccess: boolean;
  fetchCustomerOrderListError: boolean;
  orderInfo: CustomerSuspensionOrderInfo;
}

export enum CustomerSuspensionSource {
  OrderList = 'orderList',
  OrderDetails = 'orderDetails',
}

interface CustomerSuspensionOrderInfo {
  email: string;
  orders: CustomerOrder[];
}

export interface CustomerOrder {
  id: number;
  domainName: string;
  type: string;
  status: typeof ORDER_STATUSES[keyof typeof ORDER_STATUSES];
  plan: {
    isPaid: boolean;
    planType: string;
  };
  createdAt: number;
  expiryDate: string;
  billingCycle: string;
  renewalBillingCycle: string;
}

export interface RemoveCustomerSuspensionPayload {
  suspensionDetails: any;
  note: string | null;
}

export interface AddCustomerSuspensionPayload {
  userIds: number[];
  suspensionType: string;
  note: string | null;
  source: string;
  modelFeedback: string;
}

export interface SuspendEntityPayload {
  entityId: Number;
  entityType: string;
  suspensionType: string;
  metadata: {
    note: string;
    source: string;
    modelFeedback: string;
  };
}

export interface UnsuspendEntityPayload {
  entityId: Number;
  entityType: string;
  suspensionTypes: Array<string>;
  note: string;
}
